
import { ISDKInfo } from '@kontent-ai/core-sdk';
export const sdkInfo: ISDKInfo = {
    host: 'npmjs.com',
    version: '8.5.7',
    name: '@kontent-ai/management-sdk'
};
